import moment from 'moment';
import { withParams } from 'vuelidate';
export default (format) =>
	withParams({ type: 'date', format }, function (value) {
		if (typeof value === 'undefined' || value === null || value === '') {
			return true;
		}
		return moment(value, format, true).isValid();
	});
